import React from 'react';

import classNames from 'classnames/bind';
import style from './Logo.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';
import LogoIcon from './icons/Logo';

const Logo = props => (
  <Link to="/">
    <span className={ctx('logo')} id="top">
      <LogoIcon />
    </span>
  </Link>
);

export default Logo;
